import { render } from "./Seta.vue?vue&type=template&id=3ac370c3"
const script = {}
script.render = render

export default script